const topics = [
  { label: '4K蓝光专区', count: '12.8万', hot: true },
  { label: '暑期档热映', count: '9.6万', hot: true },
  { label: '豆瓣高分', count: '8.3万', hot: false },
  { label: '科幻巨制', count: '7.5万', hot: true },
  { label: '悬疑烧脑', count: '6.9万', hot: false },
  { label: '动作大片', count: '6.2万', hot: false },
  { label: '国产佳片', count: '5.8万', hot: false },
  { label: '日韩剧场', count: '5.4万', hot: true },
  { label: '经典重制', count: '4.9万', hot: false },
  { label: '纪录片精选', count: '4.3万', hot: false },
  { label: '家庭亲子', count: '3.7万', hot: false },
];

export default function Topics() {
  return (
    <section id="topics" className="py-12 md:py-16 bg-background-100">
      <div className="section-container">
        <h2 className="font-display text-2xl md:text-3xl text-foreground-950 text-center mb-2">热门话题</h2>
        <p className="text-sm text-foreground-500 text-center mb-8 md:mb-10">探索当下最受关注的影视话题与分类</p>

        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((item, i) => (
            <a
              key={i}
              href="#topics"
              onClick={(e) => e.preventDefault()}
              className="inline-flex items-center gap-2 px-4 py-2.5 rounded-full border border-background-300 bg-background-50 hover:border-primary-300 hover:bg-primary-50/50 transition-all cursor-pointer group"
            >
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-700 whitespace-nowrap">
                {item.label}
              </span>
              <span className="text-xs text-foreground-500 whitespace-nowrap">{item.count}</span>
              {item.hot && (
                <i className="ri-fire-line text-xs text-primary-500"></i>
              )}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}